import { VuexModule, Module, MutationAction, Mutation, Action, getModule } from 'vuex-module-decorators';

import store from '@/store';
import * as api from '@/api';
import * as models from '@/api/models';
import SessionModule from './session';
// import PermissionModule from '@/store/modules/permission';
import router, { updateRolesRoute } from '@/router';
import jwt from 'jsonwebtoken';
import axios from 'axios';
import * as rolesConstant from '@/constants/roles';
import ClaimTypes from '@/constants/claim-types';
import { apiSendAsync } from '@/utils/apiRequest';
// import UserName from '@/components/UserName';

export interface IUserState {
  token: string | null;

  refresh_token: string | null;

  expires_time: Date | null;

  /** 姓名 */
  name: string;
  /** 用户名（登录名） */
  username: string;
  userId: string;
  avatar: string;
  /** 角色 */
  roles: string[];

  /** 所在部门 */
  depts: string[];

  /** 超级管理员（所有系统高权限） */
  isSuperAdmin: boolean;

  /** 系统管理员（最高业务权限） */
  isSystemAdmin: boolean;

  /** 学校管理员 */
  isSchoolmAdmin: boolean;

  /** 部门管理员 */
  isDeptmAdmin: boolean;

  /** 是否会员 */
  isMember: boolean;

  /** jwt climas */
  claims: { [key: string]: string };

  info: any;
}

@Module({ dynamic: true, store, name: 'user', namespaced: true })
class User extends VuexModule implements IUserState {
  info: any = null;
  /** token, 请用 UserModule.token 获取 */
  public token: string | null = '';
  public refresh_token: string | null = '';
  public expires_time: Date | null = null;
  /** 姓名 */
  public name: string = '';
  public avatar: string = '';
  /** 角色 */
  public roles: string[] = [];
  public userId: string = '';
  /** 登录账号 */
  public username: string = '';
  public deptName: string = '';
  /** 所在部门 */
  depts: string[] = [];

  /**用户角色 */
  userType: string = '';

  claims: { [key: string]: any } = {};
  get isSuperAdmin() {
    return rolesConstant.SUPER_ADMIN_ROLES.some(o => this.roles.indexOf(o) >= 0);
  }

  get isSystemAdmin() {
    return rolesConstant.SYS_ADMIN_ROLES.some(o => this.roles.indexOf(o) >= 0);
  }

  get isSchoolmAdmin() {
    return rolesConstant.SCHOOL_ADMIN_ROLES.some(o => this.roles.indexOf(o) >= 0);
  }

  get isYlxkAdmin() {
    return rolesConstant.YLXK_ADMIN_ROLES.some(o => this.roles.indexOf(o) >= 0);
  }

  get isDeptmAdmin() {
    return rolesConstant.DEPT_ADMIN_ROLES.some(o => this.roles.indexOf(o) >= 0);
  }
  get isMember() {
    return rolesConstant.MEMBER_ROLES.some(o => this.roles.indexOf(o) >= 0);
  }

  // claims

  /** 获取数组值，如果声明只有一个，则转为数组 */
  @Action
  getClaims(claimType: string) {
    const val = this.claims[claimType];
    if (val instanceof Array) {
      return val;
    }
    return val ? [val] : [];
  }

  /** 获取单一值，如果声明有多个，则异常 */
  @Action
  getClaim(claimType: string) {
    const val = this.claims[claimType];
    if (val instanceof Array) {
      throw new Error(`声明类型 ${claimType} 有多个值.`);
    }
    return val;
  }

  @Action({ commit: 'TEST_ACTION' })
  public async TestAction() {}

  /** 用户登录  */
  @Action({ commit: 'SET_TOKEN' })
  public async Login(token: string) {
    return token;
  }

  @Action({ commit: 'SET_DATA' })
  public async SetData(obj: any) {
    return obj;
  }

  @Action({ commit: 'SET_USER_INFO' })
  public async SetUserInfo(obj: any) {
    return obj;
  }

  @Action({ commit: 'SET_TOKEN' })
  public async FedLogOut() {
    return '';
  }

  // @Action({ commit: 'SET_DATA' })
  // public async RefreshToken() {
  //   const params = new URLSearchParams();
  //   params.append('client_id', 'jsapi');
  //   params.append('grant_type', 'refresh_token');
  //   params.append('refresh_token', this.refresh_token!);
  //   const result = await axios.post(process.env.VUE_APP_ROOT + '/connect/token', params);
  //   if (result) {
  //     const info = await apiSendAsync<any>('get', '/connect/userinfo', null, null);
  //     if (info == null) {
  //       throw Error('未获取到用户信息。');
  //       return;
  //     }
  //     const token = result.data!.access_token;
  //     const refresh_token = result.data!.refresh_token;
  //     const expires_in = result.data!.expires_in;
  //     let time = new Date(new Date().getTime() + expires_in * 1000);
  //     SessionModule.ACTIVE_USER({
  //       userId: info.sub,
  //       username: this.username,
  //       deptName: this.deptName,
  //       name: this.name,
  //       token: token,
  //       refresh_token: refresh_token,
  //       expires_time: time,
  //     });
  //     return { token: token, expires_time: time, refresh_token: refresh_token };
  //   }
  //   return {
  //     token: this.token,
  //     expires_time: this.expires_time,
  //     refresh_token: this.refresh_token,
  //   };
  // }

  @MutationAction({ mutate: ['roles', 'name', 'avatar', 'username', 'userId', 'depts', 'token', 'claims', 'info'] })
  public async LogOut() {
    SessionModule.CLEAR();
    sessionStorage.clear();
    localStorage.clear();
    return {
      name: '',
      username: '',
      avatar: '',
      roles: [],
      userId: '',
      depts: [],
      token: ''!,
      claims: {},
      info: null,
    };
  }

  @Action({})
  public async GetRoutes() {
    const userDynamicRoutes = updateRolesRoute(['普通用户']);
    router.addRoutes([...userDynamicRoutes]);
  }

  /** 获取用户详细信息，保存到vuex */
  @MutationAction({ mutate: ['roles', 'name', 'avatar', 'username', 'userId', 'depts', 'token', 'claims', 'info'] })
  public async GetInfo() {
    const token = UserModule.getToken;
    const name = UserModule.getName;
    const username = UserModule.getUsername;
    const userId = UserModule.getUserId;
    if (token === undefined) {
      throw Error('GetInfo: token is undefined!');
    }
    //let url = process.env.VUE_APP_ROOT + '/connect/userinfo';

    try {
      localStorage.removeItem('user-status');
      const { data } = await api.AccountApp.getUserPersonalInfo_GET();
      if (!data) {
        localStorage.setItem('user-status', '失效用户');
        throw new Error('user not in');
      }
      const userinfo = {
        name: name,
        username: username,
        avatar: 'user',
        roles: ['普通用户'],
        userId: userId,
        depts: [],
        token: token,
        claims: {},
        info: data,
      };

      const userDynamicRoutes = updateRolesRoute(userinfo.roles);
      router.addRoutes([...userDynamicRoutes]);

      return userinfo;
    } catch (error) {
      return {
        name: '',
        username: '',
        avatar: '',
        roles: [],
        userId: '',
        depts: [],
        token: ''!,
        claims: {},
        info: null,
      };
    }
  }

  /** 初始化令牌，从本地存储中获取 */
  @Mutation
  public InitToken() {
    SessionModule.INIT();
    if (!this.token && SessionModule.getActiveSession) {
      this.token = SessionModule.getActiveSession!.token;
      this.userType = SessionModule.getActiveSession!.userType;
      this.refresh_token = SessionModule.getActiveSession!.refresh_token;
      this.expires_time = SessionModule.getActiveSession!.expires_time;
    }
  }

  @Mutation
  public SET_TOKEN(token: string) {
    if (token) {
      this.token = token;
    }
  }

  @Mutation
  public SET_DATA(obj: any) {
    if (obj != null && obj!.token) {
      this.refresh_token = obj!.refresh_token;
      this.expires_time = obj!.expires_time;
      this.token = obj!.token;
    }
  }

  @Mutation
  public SET_USER_INFO(obj: any) {
    if (obj != null && obj!.userId != null) {
      this.userId = obj!.userId;
      this.deptName = obj!.deptName;
      this.name = obj!.name;
      this.username = obj!.username;
      this.avatar = '';
      this.userType = obj.userType;
    }
  }

  get getUsername() {
    return this.username;
  }

  get getName() {
    return this.name;
  }

  get getToken() {
    return this.token;
  }

  get getUserId() {
    return this.userId;
  }

  get getRefreshToken() {
    return this.refresh_token;
  }

  get getExpiresTime() {
    return this.expires_time;
  }

  set setToken(token: string) {
    this.token = token;
  }
}
const UserModule = getModule(User);
export default UserModule;
